import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./title-slide.css";

import type { SlideViewMode } from "../slide/slide";

@customElement("bp-title-slide")
export class TitleSlide extends LitElement {
  static styles = styles;

  @property({ attribute: "artwork-src" })
  artworkSrc?: string;

  @property({ attribute: "icon-src" })
  iconSrc?: string;

  @property({ attribute: "view-mode" })
  viewMode?: SlideViewMode = "default";

  render() {
    const icon = html`
      <img class="secondary-artwork" alt="" src="${this.iconSrc}" />
    `;

    const artwork = html`
      <img class="artwork" src="${this.artworkSrc}" alt="" />
    `;

    return html`
      <div class="title-slide ${this.viewMode}">
        <div class="content">
          <slot name="session-number"></slot>
          <slot name="session-name"></slot>
          <div class="secondary-content">
            ${icon}
            <div class="secondary-title">
              <slot name="class-name"></slot>
              <slot name="teacher-name"></slot>
            </div>
          </div>
        </div>
        <div
          class="artwork-container"
        >
          ${artwork}
        </div>
      </dkv>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-title-slide": TitleSlide;
  }
}
